module.exports = __webpack_public_path__ + "files/2529be867bdb65a6f4a7c141db70c5c3.png";